import { useEffect, useRef, useCallback } from 'react';

// props: { onClickOutside: Function, enabled?: boolean, events?: string[] }
export function useDetectClickOutsideElement(props) {
  const { onClickOutside, enabled = true, events = ['click'] } = props || {};

  const containerRef = useRef(null);

  const handleClickOutside = useCallback(
    (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (typeof onClickOutside === 'function') onClickOutside();
      }
    },
    [onClickOutside]
  );

  useEffect(() => {
    if (!enabled) return;

    events.forEach((evt) => document.addEventListener(evt, handleClickOutside));

    return () => {
      events.forEach((evt) => document.removeEventListener(evt, handleClickOutside));
    };
  }, [enabled, events, handleClickOutside]);

  return { containerRef };
}



// WEBPACK FOOTER //
// ./src/hooks/useDetectClickOutsideElement/index.jsx